<template>
  <b-card no-body>
    <b-card-body class="d-flex justify-content-between align-items-center cursor-pointer" @click="onClick">
      <div class="truncate">
        <span><h3>{{ statisticTitle }}</h3></span>
        <h5 class="mb-25 font-weight-bolder">
          {{ statistic }}
        </h5>
      </div>
      <b-avatar
        :variant="`light-${color}`"
        size="45"
      >
        <feather-icon
          size="21"
          :icon="icon"
        />
      </b-avatar>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardBody,
    BAvatar,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    statistic: {
      type: [Number, String],
      required: true,
    },
    statisticTitle: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
  methods: {
    onClick(e) {
      this.$emit('onClick', e.target.value)
    }
  }
}
</script>
